module.exports = __webpack_public_path__ + "static/media/devlin-oneil.7d61a1ad.png";